import { useQuery } from "@tanstack/react-query";
import { useApi } from "./api";

export interface Memory {
  kind: string;
  eyebrow: string;
  message: string;
  link?: string;
}

interface Payload {
  generated_at: number;
  memories: Memory[];
}

export function useMemoryResurface() {
  const api = useApi();
  return useQuery({
    queryKey: ["memory-resurface"],
    queryFn: () => api.get<Payload>("/memory/resurface"),
    staleTime: 5 * 60_000, // 5 min — memory shouldn't refetch on every action
  });
}
